import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {
  UnstyledLink,
  PreloadableImage,
  tabletAndUp,
} from '@aboutyou/ui-components';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions} from '@aboutyou/tracking';
import {useIsFeatureActive} from '@aboutyou/feature-flags';

interface BASCampaignLogoProps {
  id: number;
  path: string;
  name: string;
  imagePath: string;
}

export const BASCampaignHeaderLogo: FC<BASCampaignLogoProps> = ({
  id,
  path,
  name,
  imagePath,
}) => {
  const {isActive} = useIsFeatureActive(
    'bas_homepage_campaign_takeover_tommy_hilfiger',
  );

  return (
    <BASLogoWrapper
      to={path}
      data-testid="HeaderBASLogo"
      $largerWidth={isActive}
    >
      <StyledTrackPromotions
        data-testid="HeaderBASLogoTracked"
        promotion={{
          advertisement: {
            id,
            path,
            name,
          },
          source: TrackingPromotionCreative.BasLogoIntegration,
        }}
        streamPosition={1}
      >
        <StyledPreloadableImage
          src={imagePath}
          importance="high"
          loading="eager"
        />
      </StyledTrackPromotions>
    </BASLogoWrapper>
  );
};

const BASLogoWrapper = styled(UnstyledLink)<{$largerWidth?: boolean}>`
  align-items: center;
  display: flex;
  max-width: 150px;
  padding: 2px;
  height: 100%;

  ${props =>
    props.$largerWidth
      ? tabletAndUp(css`
          max-width: 250px;
        `)
      : ''}
`;

const StyledTrackPromotions = styled(TrackPromotions)`
  display: flex;
  height: 100%;
`;

const StyledPreloadableImage = styled(PreloadableImage)`
  height: 100%;
  object-fit: contain;
  object-position: 0 center;
`;
